import { loadStripe } from "@stripe/stripe-js/pure";

import { config } from "src/config/environment";

export const stripePromise = loadStripe(config.stripe_key);
